/* eslint-disable no-unused-expressions */
import { useContext } from 'react';
import { useSelector } from 'react-redux';
import { ExternalProviderContext } from './ExternalProviderContext';
import {
  sendRequestToExternalProvider,
  discardRequestToExternalProvider,
} from '../../../actions/areas/admin/commandActions';

import { epRequestEnums } from './../../../settings/other';
import _ from '../../../utils/lodash';

const useTeamProvider = () => {
  const [state, setState] = useContext(ExternalProviderContext);

  if (state === null || state.auth === undefined) return {};

  const getOrgUnitId = useSelector(store => store.areas.dailyPlanning.filters.selectedTeam);

  const handleDetailsSidePanel = (isOpen, appointmentId, assignmentId, patientInfo) => {
    appointmentId != null && appointmentId != null
      ? setState(newState => ({
          ...newState,
          openSidePanel: isOpen,
          selectedAppointment: appointmentId,
          assignmentId,
          patientInfo,
        }))
      : setState(newState => ({ ...newState, openSidePanel: isOpen, selectedAppointment: null }));
  };
  const refreshTable = () =>
    setState(newState => ({
      ...newState,
      forceReload: !state.forceReload,
      isDataLoading: false,
      openSidePanel: false,
      errorMsg: null,
    }));
  const updateTableProps = (currentPage, pageSize) => setState({ ...state, currentPage, pageSize });
  const updateTableSort = (sortColumn, sortDirection) => setState({ ...state, sortColumn, sortDirection });

  const onClose = () => {
    setState(newState => ({ ...newState, openSidePanel: false, errorMsg: null }));
  };

  const onOpenConfirmationDialog = (actionName, requestId) => {
    setState(newState => ({
      ...newState,
      requestIds: _.concat(newState.requestIds, requestId),
      actionName,
      showActionConfirmation: true,
    }));
  };

  const handleCancel = () => {
    setState(newState => ({ ...newState, actionName: '', showActionConfirmation: false, requestIds: [] }));
  };

  const submit = values => {
    setState(newState => ({
      ...newState,
      requestStatus: values.reqStatus,
      fromDate: values.fromDate,
      toDate: values.toDate,
      orgUnitId: values.orgId,
      visitId: values.visitId,
      selectedAllForSending: false,
      requestIds: [],
    }));
  };

  const actionCallback = response => {
    setState(newState => ({
      ...newState,
      forceReload: !state.forceReload,
      message: response.data.messages ? response.data.messages[0] : null,
      showSnackbar: true,
      requestIds: [],
      selectedAllForSending: false,
      actionName: '',
      isDataLoading: false,
    }));
  };

  const handleConfirm = (actionName, entityIds, selectedAllForSending) => {
    actionName === 'Resend' || actionName === 'Send'
      ? sendRequestToExternalProvider(
          state.auth,
          { RequestIds: entityIds, AllAreCheckedFOrSending: selectedAllForSending },
          actionCallback,
        )
      : discardRequestToExternalProvider(state.auth, { RequestId: _.first(entityIds) }, actionCallback);
    setState(newState => ({ ...newState, showActionConfirmation: false }));
  };

  const handleServerAction = () => {
    setState(newState => ({
      ...newState,
      isDataLoading: true,
    }));
    sendRequestToExternalProvider(
      state.auth,
      { AllAreCheckedFOrSending: state.selectedAllForSending, RequestIds: state.requestIds },
      actionCallback,
    );
  };

  const handleCloseSnackBar = () => {
    setState(newState => ({ ...newState, showSnackbar: false }));
  };

  const handleCheckAllForSending = isChecked => {
    setState(newState => ({
      ...newState,
      selectedAllForSending: isChecked,
      requestIds: [],
    }));
  };

  const handleSingleCheck = (isChecked, id) => {
    if (isChecked) {
      setState(newState => ({
        ...newState,
        requestIds: _.concat(newState.requestIds, id),
      }));
    } else {
      setState(newState => ({
        ...newState,
        requestIds: _.filter(newState.requestIds, value => {
          return value !== id;
        }),
      }));
    }
  };

  return {
    forceReload: state.forceReload,
    sortColumn: state.sortColumn,
    sortDirection: state.sortDirection,
    currentPage: state.currentPage,
    pageSize: state.pageSize,
    selectedAppointment: state.selectedAppointment,
    assignmentId: state.assignmentId,
    patientInfo: state.patientInfo,
    actionName: state.actionName,
    showActionConfirmation: state.showActionConfirmation,
    hideActionButtons: state.hideActionButtons,
    epRequestEnums,
    orgUnitId: state.orgUnitId,
    fromDate: state.fromDate,
    toDate: state.toDate,
    selectedAllForSending: state.selectedAllForSending,
    requestIds: state.requestIds,
    requestStatus: state.requestStatus,
    message: state.message,
    openSidePanel: state.openSidePanel,
    showSnackbar: state.showSnackbar,
    getOrgUnitId,
    getStateVisitId: state.visitId,
    isDataLoading: state.isDataLoading,
    refreshTable,
    handleDetailsSidePanel,
    updateTableProps,
    updateTableSort,
    onClose,
    onOpenConfirmationDialog,
    handleCancel,
    handleConfirm,
    handleCloseSnackBar,
    handleCheckAllForSending,
    handleSingleCheck,
    handleServerAction,
    submit,
  };
};

export default useTeamProvider;
